<div class="full-page" fxLayoutAlign="center center">
    <mat-accordion [multi]="true">
        <mat-expansion-panel [disabled]="true" [expanded]="true" fxLayout="column" fxLayoutAlign="center center">
            <mat-expansion-panel-header>
                <mat-panel-title fxLayout="row" fxLayoutAlign="center center"> Přesměrování </mat-panel-title>
            </mat-expansion-panel-header>
            <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
                <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
                    <span>Právě probíhá přesměrování na aktuální krok Vaší nabídky.</span>
                    <span>Malý moment, prosím ...</span>
                </div>
                <mat-spinner diameter="40"></mat-spinner>
                <button
                    (click)="mortgagesService.goHome()"
                    class="btn btn-lg green presmerovani-aktualni-krok"
                    mat-button>
                    Zpátky na Přehled
                </button>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>
